// ANGULAR
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { M2M } from '@models/m2m.model';
import { Group } from '@models/grupos.model';
// RXJS
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GruposService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };
  
  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  getGroups(): Observable<Group[]> {
    return this.http.get<Group[]>(`${this.globalService.apiUrl.url}/Grupos`, this.httpOptions);
  }

  postCreateGroup(group: Group): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Grupos`, group, this.httpOptions);
  }

  getGroup(name: string): Observable<M2M> {
    return this.http.get<M2M>(`${this.globalService.apiUrl.url}/Grupos/${name}`, this.httpOptions);
  }

  putEditGroup(name: string, group: Group): Observable<void> {
    return this.http.put<void>(`${this.globalService.apiUrl.url}/Grupos/${name}`, group, this.httpOptions);
  }

  deleteGroup(name: string): Observable<void> {
    return this.http.delete<void>(`${this.globalService.apiUrl.url}/Grupos/${name}`, this.httpOptions);
  }
}